
import { useMemo, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getBlobName, getTokenAndFetchHeaders, getFileIcon, getFileName } from '../../utils';
import { apiRequest } from '../../utils/authConfig';
import { useMsal, account, AuthContext } from '../../utils/authContext';
import ReactGA from 'react-ga';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
const apiKey = process.env.REACT_APP_BACKEND_KEY ? process.env.REACT_APP_BACKEND_KEY : '';

interface FileProps {
    item: {
        url?: string;
        label?: string;
        description?: string;
    }
}
const FileCard = ({ item }: FileProps) => {
    const args = useMemo(() => ({ ...apiRequest, account }), []);
    const { getToken }: AuthContext = useMsal();
    const [downloading, setDownloading] = useState(false);
    const url = item.url;
    console.log(url);
    if (!item || !url) return null;

    const icon:IconProp = getFileIcon(url);

    const handleDownload = async () => {
        setDownloading(true);
        const api = process.env['REACT_APP_BACKEND_URL'];
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        const blobName = 'files/' + getBlobName(url);
        try {
            fetch(`${api}/file/download/?blobName=${encodeURIComponent(blobName)}`, {
                method: 'Get',
                headers,
            })
                .then(async res => {
                    const token = await res.text();
                    setDownloading(false);
                    const filePath = `${url}?${token}`;
                    ReactGA.event({
                        category: "File",
                        action: "download",
                        label: "File Download",
                        dimension1: filePath
                    });
                    window.location.href = filePath;
                },
                    (error) => {
                        console.error(error);
                        setDownloading(false);
                    });
        } catch (err: any) {
            console.error(err);
        }
    }
    return <Card>
        <FontAwesomeIcon style={{ display: "block", margin: "3rem auto 1rem" }} size="6x" icon={icon} />
        <Card.Body>
            <Card.Title>{item.label}</Card.Title>
            <Card.Text>{item.description}</Card.Text>
            <Card.Text>File Name: {getFileName(url)}</Card.Text>
            <Card.Text>
                <Button disabled={downloading} variant="outline-secondary" size="sm" onClick={handleDownload}>
                    {downloading ? 'Downloading ...' : 'Download'}
                </Button>
            </Card.Text>
        </Card.Body>
    </Card>
}
export default FileCard;
